<div class="box-height relative">
  <input
    autocomplete="off"
    class="form-control"
    [type]="type || 'text'"
    [id]="id"
    [name]="name"
    [class.validation-error]="validationError && !isFocused"
    [disabled]="disabled"
    [tabIndex]="tabindex"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [required]="required"
    [(ngModel)]="value"
    [pattern]="pattern || fieldValidationObject?.allowedChars"
    [maxlength]="maxlength || fieldValidationObject?.fieldAttributes?.max"
    [minlength]="minlength || fieldValidationObject?.fieldAttributes?.min"
    [apiError]="apiError"
    (blur)="onBlur()"
    (focus)="onFocus()"
    (keyup)="onChange($event)"
    [overwrite]="true"
    placeholder=" "
    tmoAllowedInput
    tmoSetFocus
    tmoAutoFocus
    [autoFocus]="autoFocus"
    [ngClass]="{
      invalid: isInputDirty || apiError,
      valid: !isInputDirty && !apiError,
      'border-rounded-tl-bl': borderRadiusTwoSides,
      'border-rounded': borderRadiusAllSides,
    }"
    class="inputText"
  />
  <span class="floating-label text-placeholder" [ngClass]="{ red: isInputDirty }"
    >{{ fieldValidationObject?.placeholder || placeholder
    }}<span *ngIf="required" class="text-required"> *</span></span
  >
  <p *ngIf="isInputDirty && !isFocused && displayError" class="small error-label position-absolute">
    {{ validationErrorText }}
  </p>
</div>
